import { render, staticRenderFns } from "./nbHandleAction.vue?vue&type=template&id=5ee5694d&scoped=true"
import script from "./nbHandleAction.vue?vue&type=script&lang=js"
export * from "./nbHandleAction.vue?vue&type=script&lang=js"
import style0 from "./nbHandleAction.vue?vue&type=style&index=0&id=5ee5694d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5694d",
  null
  
)

export default component.exports